import { render } from "./Transaction.vue?vue&type=template&id=56526393&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=56526393&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56526393"]])

export default __exports__